import { Circle } from 'react-leaflet';
import { SchoolDataDto } from '@models/schools-data';
import { RegularPolygon } from './regular-polygon';
import { LatLngExpression, PathOptions } from 'leaflet';


export const drawShoolFeature = (s: SchoolDataDto, size: number, pathOptions: PathOptions, toolTip: React.ReactElement) => {
  if (s.schoolType === 'elementary') return (
    <Circle
      center={s.schoolLatLon as LatLngExpression}
      radius={size}
      key={s.id}
      pathOptions={pathOptions}
    >
      {toolTip}
    </Circle>
  );
  if (s.schoolType === 'middle') return (
    <RegularPolygon 
      center={{ lat: s.schoolLatLon[0], lon: s.schoolLatLon[1] }}
      size={size}
      sides={4}
      key={s.id}
      pathOptions={pathOptions}
    >
      {toolTip}
    </RegularPolygon>
  );
  if (s.schoolType === 'high') return (
    <RegularPolygon 
      center={{ lat: s.schoolLatLon[0], lon: s.schoolLatLon[1] }}
      size={size}
      sides={6}
      key={s.id}
      pathOptions={pathOptions}
    >
      {toolTip}
    </RegularPolygon>
  );
  return (<></>);
};
